import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { judgeObj } from '@/shared/functions';
import { dispatch } from '@@/store';
const initState = {
    _loop: 0,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         * @desc 主动获取车辆是否结束接口
         * @argument 轮询场景 长连接断开
         * @argument 轮询时长 200ms
         */
        loop(payload, { update, state, rootState }) {
            this.CLEAR__LOOP();
            // 如果是大屏页面再轮询 如果是拍卖师页面不轮询
            const { path } = rootState.router;
            if (path.includes('screen')) {
                this.loopFunction({});
                const _loop = setInterval(() => __awaiter(this, void 0, void 0, function* () {
                    this.loopFunction({});
                }), 200);
                this.SET__LOOP(_loop);
            }
        },
        /**
         * @desc 轮询函数
         */
        loopFunction(payload, { update, state, rootState }) {
            const { nowCarAuctionId, sessionId, isFormal, sessionStatus } = rootState.screen;
            if (!sessionId || !nowCarAuctionId) {
                console.log('因缺少连接断开的轮询参数，此次轮询请求不执行');
                return;
            }
            if (sessionStatus === 'end') {
                console.log('场次都结束了，我们就关闭轮询吧');
                this.CLEAR__LOOP();
                return;
            }
            const _param = {
                roundId: sessionId,
                auctionId: nowCarAuctionId,
                stopThisAuction: 0,
            };
            Api.auction.hasEndOfTheAuction(_param).then((_r) => {
                console.log('长连接断开的轮询机制，大屏结束接口返回_r', _r);
                const data = JSON.parse(JSON.stringify(_r));
                if (judgeObj(data)) {
                    // 场次结束
                    if (data.roundStatus === 3) {
                        this.CLEAR__LOOP();
                        dispatch.screen.dealEnd({ id: sessionId });
                        return;
                    }
                    if (judgeObj(data.auctionInfo)) {
                        const { auctionInfo } = data;
                        const { auctionId, roundSimulateStatus } = auctionInfo;
                        // 场次变更 || 车辆变更 重新请求接口
                        const _isFormal = (roundSimulateStatus === 0) === isFormal;
                        if (!_isFormal || nowCarAuctionId !== auctionId) {
                            dispatch.screen.load({});
                        }
                        // 随时更新详情
                        const { status, theLastCar, countNum, auctionPriceW, priorityOfferW, countDownStatus, bidStatus, finalOfferW, brokerageW, commissionW, exceedBasePrice, bidType, } = auctionInfo;
                        dispatch.screen.SET_STATE({
                            isFormal: roundSimulateStatus === 0 ? true : false,
                            isTheLast: theLastCar,
                            beginPrice: auctionPriceW,
                            carResult: status,
                            countNum,
                            currentPrice: priorityOfferW,
                            answerPrice: priorityOfferW,
                            nowCarAuctionId: auctionId,
                            bidStatus,
                            countDownStatus: countDownStatus === 1,
                            finalOfferW,
                            brokerageW,
                            commissionW,
                            exceedBasePrice,
                            bidType,
                        });
                        // 竞价倒计时
                        if (status === 3 && (countDownStatus === 1)) {
                            dispatch.screen.goToCount({ countNum, type: 'duringAuction' });
                            return;
                        }
                        // 应价倒计时
                        if (status === 81 || status === 8) {
                            dispatch.screen.goToCount({ countNum, type: 'duringAnswer' });
                            return;
                        }
                        // 车辆倒计时
                        if (status === 5 || status === 50 || status === 51 || status === 6) {
                            dispatch.screen.goToCount({ countNum, type: 'duringEndCar' });
                            return;
                        }
                        // loop
                        if (status === 4 || status === 30 || status === 80) {
                            dispatch.screen.loop({});
                            return;
                        }
                    }
                }
            });
        },
        /**
         * @desc 取消轮询
         */
        stopLoop() {
            console.log('关闭轮询');
            this.CLEAR__LOOP();
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SET__LOOP(state, payload) {
            state._loop = payload;
        },
        CLEAR__LOOP(state) {
            clearInterval(state._loop);
            state._loop = 0;
        },
    },
});
